import { QueryClient } from "@tanstack/react-query"

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: { retry: 1, staleTime: 20_000, refetchOnWindowFocus: true },
        mutations: { retry: false },
    },
})
